import vuetify from "@/plugins/vuetify";
import store from "@/store";
import i18n from "@/language/i18n";
import Vue from "vue";

export default function (globalDialog, props = {}) {
    const GlobalDialog = Vue.extend(globalDialog);

    return new GlobalDialog({
        vuetify,
        store,
        i18n,
        propsData: props
    }).$mount();
}
